<template>
<div class="look-account">
   <el-card class="box-card">
    <div slot="header" class="clearfix" style="text-align:left;">
      <a style="text-decoration:none;color:#337ab7;cursor:pointer;" @click="returnBack">返回</a>
      <span style="line-height: 36px;margin-left:60px;">公众号：</span>
      <span>{{appName}}</span>
      <span>{{appId}}</span>
      <span style="color:#337ab7;">总数:{{count}}</span>

      <el-button style="float: right;margin-left:10px;" type="success" @click="queryUserStaticList(pageNo,pageSize,appId)">查询</el-button>
            <el-date-picker
                style="float: right;"
                v-model="date_value"
                type="daterange"
                align="right"
                :placeholder="today">
        </el-date-picker>
    </div>
    <div>
      <el-table
      v-loading="table_loading"
      element-loading-text="拼命加载中"
      :data="deviceData"
      stripe
      border
      fit
      @selection-change="handleSelectionChange"
      style="width: 100%">
      <el-table-column
        prop="nickname"
        header-align="center"
        min-width="50"
        label="昵称">
      </el-table-column>
       <el-table-column
        prop="totalCount"
        header-align="center"
        min-width="30"
        label="总取量">
      </el-table-column>
      <el-table-column
        prop="head_img_url"
        header-align="center"
        min-width="115"
        label="头像地址">
        <template scope="scope">
                      <el-popover
                      ref="popoverPayStatus1"
                      placement="right-start"
                      trigger="hover">
                          <img  :src="scope.row.head_img_url" style="width:220px;"/>
                      </el-popover>
                      <a style="color: #337ab7;text-decoration: none;" v-popover:popoverPayStatus1 :href="scope.row.head_img_url" target="_blank">{{scope.row.head_img_url}}</a>
                    </template>
      </el-table-column>
      <el-table-column
        prop="deviceCode"
        header-align="center"
        min-width="50"
        label="设备编号">
      </el-table-column>
       <el-table-column
        prop="sex"
        header-align="center"
        min-width="20"
        label="性别">
        <template scope="scope">
          <el-tag :type="scope.row.sex === '2' ? 'danger' : 'success'"
            close-transition>{{scope.row.sex}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="outTime"
        header-align="center"
        min-width="50"
        label="取货时间">
      </el-table-column>
      <el-table-column
        prop="os"
        header-align="center"
        min-width="30"
        label="操作系统">
      </el-table-column>
    </el-table>
    </div>
    <div class="table_pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </el-card>
  <!-- <pu-see-pop-right 
    v-if="seeShow"
    :see-pop-right-ok="seePopRightOk" 
    :device-code="deviceCode"
    :see-type = 'seeType'
    @closeSeeRightPop="closeSeeRightPop">
  </pu-see-pop-right> -->
  </div>
</template>
<script>
    import $axios from '../../https/config'
    import puSeePopRight from '@/page/deviceMgr/seePopRight'
    // import {isNull} from '../../js/tool'

    export default {
      data () {
        return {
          deviceData: [],
          today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' - ' + new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          date_value: '',
          user_account: '',
          points: 0,
          balance: 0,
          appId: this.$route.query.appId,
          appName: this.$route.query.appName,
          count: this.$route.query.count,
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          openid: "",
          ad_openid: "",
          nickname: '',
          head_img_url: '',
          sex: 0,
          os: "",
          totalCount:0,
          deviceCode:""
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryUserStaticList(this.pageNo, this.pageSize, this.appId)
      },
      methods: {
        queryUserStaticList (tPageNo, tPageSize,appId) {
          var _this = this
          var sDate =  this.date_value[0]? new Date(this.date_value[0]):new Date();
          var eDate = this.date_value[1]? new Date(this.date_value[1]): new Date();
          var tStartDate = sDate.getFullYear() + '-' + (sDate.getMonth() + 1) + '-' + sDate.getDate()
          var tEndDate = eDate.getFullYear() + '-' + (eDate.getMonth() + 1) + '-' + eDate.getDate()
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            appid: _this.appId,
            startDate: tStartDate,
            endDate: tEndDate
          }
          this.table_loading = true
          $axios.get('/statictis/getUserByStatictisDate', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var temp = '男';
                  if(0 === itemData.sex){
                    temp = '未知';
                  }
                  if(1 === itemData.sex){
                    temp = '男';
                  }
                  if(2 === itemData.sex){
                    temp = '女';
                  }
                  var item = {
                    user_account:  itemData.user_account,
                    points:  itemData.points,
                    balance:  itemData.balance,
                    openid:  itemData.openid,
                    ad_openid:  itemData.ad_openid,
                    nickname:  itemData.nickname,
                    head_img_url:  itemData.head_img_url,
                    sex:  temp,
                    outTime:_this.getNowFormatDate(new Date(itemData.outTime),'-').currentdateHMS,
                    totalCount :itemData.totalCount,
                    deviceCode:itemData.deviceCode,
                    os:  itemData.os
                  }
               
                  resData.push(item)
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },

        seeNext (mSeeType, mDeviceCoe) {
          this.deviceCode = mDeviceCoe
          this.seeType = mSeeType
          this.seePopRightOk = true
          this.seeShow = true
        },
        getNowFormatDate(date = new Date(), slot = "/") { //时间格式化
          let seperator1 = slot;
          let seperator2 = ":";
          let month = date.getMonth() + 1;
          let strDate = date.getDate();
          let getHours = date.getHours();
          let getMinnute = date.getMinutes();
          let getSeconds = date.getSeconds();

          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
          }
          if (getMinnute >= 0 && getMinnute <= 9) {
            getMinnute = "0" + getMinnute;
          }
          if (getSeconds >= 0 && getSeconds <= 9) {
            getSeconds = "0" + getSeconds;
          }
          let currentdate = {
            Year: date.getFullYear(),
            month, //月
            strDate, //天
            getHours, //小时
            getMinnute, //分钟
            currentdate: date.getFullYear() + seperator1 + month + seperator1 + strDate,
            currentdateHM: date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 + getMinnute,
            currentdateHMS: date.getFullYear() + seperator1 + month + seperator1 + strDate + " " + date.getHours() + seperator2 + getMinnute + seperator2 + getSeconds
          }
      console.log(currentdate)
          return currentdate;
        },
        closeSeeRightPop () {
          this.seePopRightOk = false
          this.queryUserStaticList(this.pageNo, this.pageSize, this.appId)

        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryUserStaticList(this.pageNo, this.pageSize, this.appId)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryUserStaticList(this.pageNo, this.pageSize, this.appId)
        },
        handleSelectionChange (selection) {
          this.multipleSelection = ''
          for (var i = 0; i < selection.length; i++) {
            this.multipleSelection += (selection[i].code + '|')
          }
        },
        searchInput () {
        },
        returnBack () {
          this.$router.back(-1)
        }
      },
      components: {
        'pu-see-pop-right': puSeePopRight
      }
    }
</script>
<style lang="scss">
    .table_pagination {
      text-align: right;
      margin-top: 10px; 
    }
    .look-account {
      .el-select .el-input {
        width: 110px;
      }
    }
</style>


// WEBPACK FOOTER //
// src/page/deviceInfo/wxUserInfo.vue